import { createSlice } from "@reduxjs/toolkit";
import { LoadingModalProps } from "../../models";

export const EmptyLoadingState: LoadingModalProps = {
   openLM:false,
   messageLM:''
}

export const loadingSlice = createSlice({

    name:"loading",
    initialState: EmptyLoadingState,
    reducers: {
        
        updateLoading: (state, action) => ( { ...state, ... action.payload } ),

        resetLoading: () => EmptyLoadingState

    }
});


export const {updateLoading, resetLoading } = loadingSlice.actions;

export default loadingSlice.reducer;